module.exports = __webpack_public_path__ + "static/step-3.841bc00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/dialogs/step-3.png
// module id = 197
// module chunks = 105782860971035 173053574358268